module.exports = __webpack_public_path__ + "static/banner-78b5c2193640e7d62cfc7c2f0cd1198f.jpg";